export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

export const TokenDollar = (number: number) => {
    return new Intl.NumberFormat().format(number);
}